// Eine Byte-Zahl so schreiben, dass ein Mensch sie liest.
//
// ⚠️ Warum das hier steht und nicht (mehr nur) in `bunnyCDNService`: die Funktion war eine Methode
// des Bunny-Dienstes und hatte dort zwei Aufrufer in der Mediathek. Als die Fassungs-Übersicht sie
// als dritten brauchte, standen zwei Wege offen — eine zweite Rechnung danebenschreiben oder den
// Redaktions-Baustein an den Bunny-Dienst hängen. Beide sind gemessen schlecht:
//
//   • Zweite Rechnung: genau die Klasse „zwei Fassungen derselben Sache", die im BACKLOG § 4 schon
//     zweimal steht (`CategoryVideoCard` neben `MediaCard`, zwei Rasterregeln).
//   • Anhängen an den Dienst: `bunnyCDNService` zieht über `lib/authToken` den Supabase-Client mit,
//     und der ruft beim Modul-Laden `createClient`. Nachgemessen, nicht vermutet: der Import einer
//     Formatierfunktion brachte damit `AudioManagement.test.tsx` zum Absturz („supabaseUrl is
//     required"), obwohl die Seite mit Supabase nichts zu tun hat.
//
// Hier hat sie keine Importe und damit keine Nebenwirkung. `bunnyCDNService.formatFileSize` bleibt
// als Methode bestehen und reicht hierher durch — seine Aufrufer und deren Attrappen unverändert.

/**
 * Formatiert eine Byte-Zahl mit Binärpräfix (1 KB = 1024 Bytes).
 *
 * Die Rechnung ist die bisherige aus `bunnyCDNService`, unverändert übernommen — samt der
 * Sonderbehandlung der 0, die sonst als `NaN` herauskäme (`Math.log(0)` ist `-Infinity`).
 */
export function formatiereDateigroesse(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}
